<template>
  <v-app :dark="getDarkMode">
    <v-content :class="{ 'has-alert': !isOnline }">
      <v-alert :value="!isOnline" type="warning" transition="slide-y-transition" class="alert">
        Você está navegando no modo offline.
      </v-alert>
      <v-layout align-center justify-center row fill-height v-if="!getFirstLoading">
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate/>
      </v-layout>
      <snackbar/>
      <router-view v-if="getFirstLoading"/>
    </v-content>
  </v-app>
</template>

<script>
import Snackbar from '@/components/Snackbar'
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  components: { Snackbar },
  computed: mapGetters('App', ['getDarkMode', 'getFirstLoading']),
}
</script>

<style scoped>
.alert {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  margin: 0;
  z-index: 999;
}

.has-alert {
  padding: 64px 0px 0px !important;
}

@media print {
  .v-content {
    padding-top: 0 !important;
    padding-left: 0 !important;
  }
}
</style>

<style>
@media print {
  #app {
    background: white !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue